// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u1tD","question":"styles_question__QGoQZ","description":"styles_description__2CxYN"};